export const PERMISSIONS = {
  admin: 'admin',
  guest: 'guest',
  operator: 'operator',
  technician: 'technician',
};
